<template>
  <div class="study_type_manage">
    <el-divider content-position="left">小程序上传图片管理</el-divider>
    <el-row>
      <el-col :span="12">
        <el-select
          v-model="searchArr.pid"
          filterable
          remote
          reserve-keyword
          placeholder="请输入名称"
          size="mini"
          clearable
          :remote-method="searchRemotePic"
          :loading="searchLoading"
          @change="handleSearchPic"
        >
          <el-option
            v-for="searchItem in searchPics"
            :key="searchItem.id"
            :label="searchItem.pic_name"
            :value="searchItem.id"
          >
          </el-option>
        </el-select>
        <el-select
          clearable
          v-model="searchArr.type"
          placeholder="请选择分类"
          size="mini"
          @change="cateSearch"
        >
          <el-option label="微信小程序" value="微信小程序"></el-option>
          <el-option label="支付宝小程序" value="支付宝小程序"></el-option>
        </el-select>
      </el-col>
      <el-col :span="12" class="tr" style="margin-bottom: 0.2rem">
        <el-button type="primary" size="mini" @click="handleAddOpen">上传</el-button>
      </el-col>
    </el-row>
    <el-table :data="miniProPicList" size="medium" style="width: 100%" border>
      <el-table-column
        v-for="(item, index) in col"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
      >
      </el-table-column>
      <el-table-column label="链接" prop="pic_link">
        <template slot-scope="scope">
          <div style="cursor: pointer; width: 100%">
            <span
              @click="handlePictureCardPreviewS(scope.row.pic_link)"
              style="color: #409eff"
              >{{ scope.row.pic_link }}</span
            >
            <el-tooltip class="item" effect="dark" content="复制链接" placement="top">
              <i
                class="el-icon-document-copy"
                style="margin-left: 0.1rem; cursor: pointer"
                @click="copyLink(scope.row.pic_link)"
              ></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">
            编辑
          </el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[15, 30]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>

    <el-dialog
      title="上传图片"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleAddClose"
    >
      <div>
        <el-row class="mb-10">
          <el-input
            placeholder="请输入名称"
            v-model="addData.name"
            size="small"
            clearable
          >
          </el-input>
        </el-row>
        <el-row>
          <el-select
            style="width: 100%"
            clearable
            v-model="addData.type"
            placeholder="请选择分类"
            size="small"
          >
            <el-option label="微信小程序" value="微信小程序"></el-option>
            <el-option label="支付宝小程序" value="支付宝小程序"></el-option>
          </el-select>
        </el-row>
        <el-row class="mb-10">
          <el-upload
            class="upload-demo"
            :headers="uploadHeader"
            :action="actionHost + '/api/admin/mini_pro/pic/manage/0'"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :file-list="materialFileList"
            list-type="picture"
            :on-success="handleAddCoverSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <el-button v-if="!addCoverUrl" size="mini" type="primary">点击上传</el-button>
            <div slot="tip" v-if="false" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleAddClose">取 消</el-button>
        <el-button type="primary" size="mini" @click="handleAdd">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="编辑图片"
      :visible.sync="editVisible"
      width="30%"
      :before-close="handleEditClose"
    >
      <div>
        <el-row class="mb-10">
          <el-input
            placeholder="请输入名称"
            v-model="editData.name"
            size="small"
            clearable
          >
          </el-input>
        </el-row>
        <el-row class="mb-10">
          <el-select
            style="width: 100%"
            clearable
            v-model="editData.type"
            placeholder="选择分类"
            size="small"
          >
            <el-option label="微信小程序" value="微信小程序"></el-option>
            <el-option label="支付宝小程序" value="支付宝小程序"></el-option>
          </el-select>
        </el-row>
        <el-row class="mb-10">
          <el-upload
            class="upload-demo"
            :headers="uploadHeader"
            :action="actionHost + '/api/admin/mini_pro/pic/manage/' + editData.id"
            :on-preview="handleSavePictureCardPreview"
            :on-remove="handleSaveRemove"
            :file-list="materialFileListSave"
            list-type="picture"
            :on-success="handleSaveCoverSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <el-button v-if="!editCoverUrl" size="mini" type="primary"
              >点击上传</el-button
            >
            <div slot="tip" v-if="false" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleEditClose">取 消</el-button>
        <el-button type="primary" size="mini" @click="handleSave">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog width="30%" :visible.sync="dialogVisibleShowImg">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "MiniProgramPic",
  data() {
    return {
      uploadHeader: { Authorization: localStorage.token },
      imgPath: this.$store.state.imgPath,
      miniProPicList: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 15, // 每页显示条数
      },
      searchArr: {
        pid: "",
        type: ""
      },
      searchLoading: false,
      searcher: "",
      searchPics: [],
      col: [
        {
          label: "ID",
          width: "80",
          prop: "id",
        },
        {
          label: "名称",
          width: "130",
          prop: "pic_name",
        },
      ],
      needDeleteId: "",
      dialogVisible: false,
      editVisible: false,
      addData: {
        name: "",
        type: "",
        pic_link: "",
      },
      editData: {
        id: null,
        name: "",
        type: "",
        pic_link: "",
      },
      addCoverUrl: "",
      editCoverUrl: "",
      dialogVisibleShowImg: false,
      dialogImageUrl: "",
      materialFileList: [],
      materialFileListSave: [],
      needUrl: [],
    };
  },
  computed: {
    actionHost: {
      get: function () {
        // http://192.168.1.110
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    // 列表
    getMiniProPicList() {
      this.$axios
        .get(
          "/api/admin/mini_pro/pic/manage_list?page=" +
            this.pageOption.currentPage +
            "&pageSize=" +
            this.pageOption.pageSize +
            "&searchItem=" +
            this.searcher +
            "&type=" + this.searchArr.type
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            // console.log(data);return;
            this.miniProPicList = data.data.list.data;
            this.pageOption.total = data.data.list.total;
          }
        });
    },
    cateSearch () {
      this.pageOption.currentPage = 1
      this.getMiniProPicList()
    },
    searchRemotePic(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchItem(query);
        }, 200);
      } else {
        this.searchPics = [];
      }
    },
    searchItem(query) {
      this.$axios
        .get("api/admin/mini_pro/pic/get_item", {
          params: {
            search: query,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchPics = data.data;
          }
        })
        .catch();
    },
    handleSearchPic(query) {
      this.searcher = query;
      setTimeout(() => {
        this.getMiniProPicList();
      });
    },
    handleAddCoverSuccess(res, file) {
      if (res.code === 0) {
        this.addCoverUrl = URL.createObjectURL(file.raw);
        this.materialFileList.push({
          name: file.name,
          url: res.data.info.url,
        });
        this.addData.pic_link = res.data.info.url;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleSaveCoverSuccess(res, file) {
      if (res.code === 0) {
        this.editCoverUrl = URL.createObjectURL(file.raw);
        this.materialFileListSave.push({
          name: file.name,
          url: res.data.info.url,
        });
        this.editData.pic_link = res.data.info.url;
      } else {
        this.$message.error(res.msg);
      }
    },

    beforeAvatarUpload(file) {
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$message.error("封面只能是 JPG、PNG 格式!");
        return false;
      }
      return true;
    },

    // 添加删除
    handleRemove(file) {
      this.$axios
        .post("/api/admin/mini_pro/pic/delete", { url: file.url })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.addData.pic_link = "";
            this.materialFileList = [];
            this.addCoverUrl = "";
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    // 预览
    handlePictureCardPreviewS(url) {
      // this.dialogImageUrl = url;
      const timestamp = new Date().getTime(); // 获取当前时间戳
      this.dialogImageUrl = url + '?timestamp=' + timestamp;
      this.dialogVisibleShowImg = true;
    },
    // 添加预览
    handlePictureCardPreview(url) {},

    // 编辑删除
    handleSaveRemove(file) {
      this.$axios
        .post("/api/admin/mini_pro/pic/delete", { url: file.url, id: this.editData.id })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.editData.pic_link = "";
            this.materialFileListSave = [];
            this.editCoverUrl = "";
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleSavePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
    },

    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getMiniProPicList()
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getMiniProPicList()
    },
    handleAddOpen() {
      this.dialogVisible = true;
    },
    handleAdd() {
      if (!this.addData.name) {
        this.$message.error("请输入名称！");
        return;
      }
      if (!this.addData.pic_link) {
        this.$message.error("请上传图片！");
        return;
      }

      this.$axios
        .post("/api/admin/mini_pro/pic/manage_create", {
          name: this.addData.name,
          pic_link: this.addData.pic_link,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.getMiniProPicList();
            this.handleAddClose();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },

    handleAddClose() {
      this.addData.name = "";
      this.addData.type = "";
      this.addCoverUrl = "";
      this.addData.pic_link = "";
      this.materialFileList = [];
      this.dialogVisible = false;
    },
    handleEdit(index, row) {
      this.editData.id = row.id;
      this.editData.name = row.pic_name;
      this.editData.type = row.type
      this.editData.pic_link = row.pic_link;
      if (row.pic_link) {
        this.materialFileListSave.push({
          url: row.pic_link,
        });
      }
      this.editCoverUrl = row.pic_link;
      this.editVisible = true;
    },
    handleDelete(index, row) {
      this.$confirm('确定要删除当前图片吗？', '提示',  {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/api/admin/mini_pro/pic/manage_delete', {id: row.id}).then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.getMiniProPicList();
          } else {
            this.$message.error(data.msg)
          }
        })
      }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！',
          })
      })
    },
    handleSave() {
      if (!this.editData.id) {
        this.$message.error("请求错误！");
        return;
      }
      if (!this.editData.name) {
        this.$message.error("名称不能为空");
        return;
      }
      if (!this.editData.pic_link) {
        this.$message.error("请上传图片");
        return;
      }

      this.$axios
        .post("/api/admin/mini_pro/pic/manage_create", {
          id: this.editData.id,
          name: this.editData.name,
          type: this.editData.type,
          pic_link: this.editData.pic_link,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.getMiniProPicList();
            this.handleEditClose();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleEditClose() {
      this.editData.id = null;
      this.editData.name = "";
      this.editData.type = "";
      this.editData.pic_link = "";
      this.materialFileListSave = [];
      this.editCoverUrl = "";
      this.editVisible = false;
    },
    copyLink(data) {
      // 存储传递过来的数据
      let link = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = link;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
  },
  mounted() {
    this.getMiniProPicList();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

.study_type_manage {
  marginLeft();
}

.study_type_manage >>> .el-table__header th {
  color: #333333;
  background-color: #ECF4FF;
}

.mb-10 {
  margin-bottom: 0.2rem;
  margin-top: 0.4rem;
}

.m-label {
  line-height: 0.64rem;
}

.tr {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting_panel/MiniProgramPic.vue